import React, {useState} from "react";
import {useObserver} from "mobx-react-lite";
import {useTranslation} from "react-i18next";
import {Col, Row, Skeleton} from "antd";

import {useSubCompanies} from "../../../hooks/useSubCompanies";
import {PoolForm} from "../components/poolForm/PoolForm";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";

const EditPool = ({poolId}) => {
    const {t} = useTranslation(["pools"]);
    const stores = useStore();

    const [subCompanySearchText, setSubCompanySearchText] = useState("");
    const {subCompanies, subCompanyLoading, loadSubCompanies} = useSubCompanies({});
    const [selectedSubCompanies, setSelectedSubCompanies] = React.useState([]);
    const handleSelectedSubCompaniesChange = selectedSubCompanyIds => {
        const selectedSubCompanies = subCompanies.filter(subCompany =>
            selectedSubCompanyIds.includes(subCompany._id.toString())
        );
        setSelectedSubCompanies(selectedSubCompanies);
    };
    const [loading, pool] = useFetch({
        fetchFn: stores.poolStore.getPool.bind(null, {poolId}),
        initialCall: true,
        defaultDataValue: null,
        callbackFunc: pool => {
            loadSubCompanies({
                companyIds: pool?.companies?.map(company => company._id.toString()) || [],
                searchText: subCompanySearchText
            });
        }
    });

    return useObserver(() => (
        <Row type="flex" justify="center" data-testid="editPoolScreen" gutter={[0, 20]}>
            {!pool || loading ? (
                <Skeleton paragraph={{rows: 2, width: "100%"}}></Skeleton>
            ) : (
                <>
                    <Col span={20}>
                        <h1>{t("screens.editPool", {ns: "pools"})}</h1>
                        <PoolForm
                            pool={pool}
                            type="edit"
                            subCompanySearchText={subCompanySearchText}
                            setSubCompanySearchText={setSubCompanySearchText}
                            subCompanyOptions={subCompanies}
                            subCompanyOptionsLoading={subCompanyLoading}
                            loadSubCompanies={loadSubCompanies}
                            onSelectedSubCompaniesChange={handleSelectedSubCompaniesChange}
                        />
                    </Col>
                </>
            )}
        </Row>
    ));
};

export default EditPool;
